import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ScreenFrame, ListCard, ViewToggle } from '../PrototypeShared';

const MOCK_DOCS = [
  { id: 'D1', ref: 'VOR 2401372', supplier: 'Supplier A', date: '2024-03-01' },
];

export default function SupplierDocumentsScreen() {
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Supplier documents"
      actions={
        <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
      }
    >
      {view === 'list' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {MOCK_DOCS.map((d) => (
            <ListCard key={d.id} title={d.ref} subtitle={`${d.supplier} · ${d.date}`} to={`/prototype/incoming-deliveries/1`} />
          ))}
        </Box>
      )}
      {view === 'empty' && <Typography color="text.secondary">No supplier documents.</Typography>}
    </ScreenFrame>
  );
}
